import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Select from 'react-select';
import customStyles from "../common/scripts/customStylesSelect";
import { api } from "../common/scripts/api";
import { Alert } from 'react-bootstrap';
import { DatePicker } from "office-ui-fabric-react/lib/DatePicker";
import { initializeIcons } from "@uifabric/icons";

const isAlphanumeric = (string) => {
  const expresion = /^[a-z0-9]+$/i;
  return expresion.test(string);
}
const renderThumbVertical = ({ style, ...props }) => {
  return (
    <div
      {...props}
      style={{
        ...style,
        backgroundColor: "#59482d6b",
        borderRadius: "9999999999px",
        width: "6px",
        opacity: "1",
      }}
    />
  );
};
export const MenuList = (props) => {
  return (
    <div
      style={{
        height:
          props.children && props.children.length > 0
            ? 40 * props.children.length
            : 82,
      }}
    >
      <Scrollbars renderThumbVertical={renderThumbVertical}>
        {props.children}
      </Scrollbars>
    </div>
  );
};

class Cards extends React.Component {
  render() {
    return (
      <div classExtra={'card_ingresar_datos_container CardsContainer'} 
        data-testid="cards container"
      >
        {this.props.children && 
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              marginTop: '3px',
            }}
          >{this.props.children}</div>
        }
      </div>
    )
  }
}

export class Auth extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tipoDocSelected: null,
      numeroDoc: "",
      dateBirth: null,
      captchaVerified: false,
      captchaError: false,
      show: true,
    }
    this.dayPickerStrings = {
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      shortMonths: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sept",
        "Oct",
        "Nov",
        "Dic",
      ],
      days: [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ],
      shortDays: ["D", "L", "M", "M", "J", "V", "S"],
      goToToday: "Hoy",
      prevMonthAriaLabel: "Mes anterior",
      nextMonthAriaLabel: "Siguiente mes",
      prevYearAriaLabel: "Año anterior",
      nextYearAriaLabel: "Siguiente año",
      isRequiredErrorMessage: "Campo requerido",
      invalidInputErrorMessage: "Formato de fecha invalida",
    };
    this.handleTipoDocSelect = this.handleTipoDocSelect.bind(this)
    this.handleResponseSurvey = this.handleResponseSurvey.bind(this)
    this.handleDismiss = this.handleDismiss.bind(this);
    this.inputDate = this.inputDate.bind(this);
    this.handleBirthDayChange = this.handleBirthDayChange.bind(this);
  }

  componentDidMount() {
    initializeIcons(undefined, { disableWarnings: true });
    let token = ''
    let pnpService = new ServicioPnp();
    pnpService.getListWithTop(
      "configuraciones",
      (list) => {
        list.forEach((item) => {
          if(item.CSNombreText === 'GoogleCaptchaKey') token = item.CSValorNote
        });
        if(grecaptcha && grecaptcha.render) {
          grecaptcha.render('g-recaptcha', {
            'sitekey' : token,
            'callback' : verifyCallback,
            'theme' : 'light'
          });
        }else{
          let interval = setInterval(() => {
            clearInterval(interval)
            if(grecaptcha && grecaptcha.render) {
              grecaptcha.render('g-recaptcha', {
                'sitekey' : token,
                'callback' : verifyCallback,
                'theme' : 'light'
              });
            }
          }, 2000)
        }
        
      },
      500,
      null
    );
    const verifyCallback = () => {
      this.setState({
        captchaVerified: true,
      })
    }   
  }

  handleBirthDayChange = (value) => {
    this.setState({
      dateBirth: value,
    })
  }

  showErrorMessage = (message) => {
    this.props.getErrorMessage(
      message,
      "Cerrar",
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.True"
      )
    );
    this.setState({ error: true });
    compensar.quitarLoading("#Landing-Encuestas");
  }
  
  continueHandler(userTypeIdTemp, userIdTemp, captchaVerifiedTemp) {
    compensar.mostrarLoading("#Landing-Encuestas");
    const date = this.state.dateBirth;
    let month =
      (date.getMonth() + 1).toString().length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    let day =
      date.getDate().toString().length === 1
        ? "0" + date.getDate()
        : date.getDate();
    let year = date.getFullYear();

    const dateBirth = `${year}${month}${day}`;
    
    const userTypeId = userTypeIdTemp || this.state.tipoDocSelected.userTypeId;
    const userId = userIdTemp || this.state.numeroDoc;
    const captchaVerified = captchaVerifiedTemp || this.state.captchaVerified;
    if(
      userTypeId &&
      userId &&
      dateBirth &&
      captchaVerified
    ){
      sessionStorage.setItem('userTypeId', userTypeId);
      sessionStorage.setItem('userId', userId);
      this.setState({captchaError: false})
      
      api.post(
        `/_vti_bin/Servicios/ServicioTransarSurvey.svc/CheckUserAccessDateBirth`,
        {
          userTypeId,
          userId,
          dateBirth,
        }
      ).then((responseCheck) => {
        if(!responseCheck.data.Result.Acceso) {
          return this.showErrorMessage('Lo sentimos, los datos ingresados no coinciden.');
        }
        api.post(
          `/_vti_bin/Servicios/ServicioTransarSurvey.svc/GetUserBasicDataSurveysl`,
          {
            userTypeId,
            userId,
          }
        ).then((response) => {
          let data;
          if(response.data.GetUserBasicDataSurveyslResult) {
            if (response.data.GetUserBasicDataSurveyslResult?.ResponseCode === 200 && response.data.GetUserBasicDataSurveyslResult?.Result?.ConsultarAfiliadoOut === null) {
              console.log(resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Modal"
              ));
              return this.showErrorMessage(resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Modal.msgNoEstaAfiliado"
              ));
            }
            if(response.data.GetUserBasicDataSurveyslResult?.Result?.ConsultarAfiliadoOut) {
              data = response.data.GetUserBasicDataSurveyslResult;
              // const FecNacimiento = data.Result.ConsultarAfiliadoOut.datosBasicos[0]?.FecNacimiento;
              // if(FecNacimiento !== dateBirth) {
              //   return this.showErrorMessage('Lo sentimos, los datos ingresados no coinciden.');
              // }
            } else {
              return this.showErrorMessage('Lo sentimos, los datos ingresados no coinciden.');
            }
          }
          if(!data) {
            this.showErrorMessage(data.ResponseDetail);
          }
          if (data.ResponseCode === 200 && data.Result.ConsultarAfiliadoOut) {
            const programaAccess = data.Result.ConsultarAfiliadoOut.pROGRAMA.filter(el => el.IndicadorPrestacion === 'S')
            // Si hay un elemento con IndicadorPrestacion en S, entonces tiene acceso
            if(programaAccess.length > 0) {
              this.getSurveys({
                userTypeId,
                userId,
              }, this.handleResponseSurvey)
            } else {
              this.props.getErrorMessage(
                "Lo sentimos, no tiene acceso.",
                "Cerrar",
                sharedResources.getResource(
                  "es",
                  "nsGeneralResources",
                  "Modal.Bolean.False"
                ),
                sharedResources.getResource(
                  "es",
                  "nsGeneralResources",
                  "Modal.Bolean.True"
                )
              );
              compensar.quitarLoading("#Landing-Encuestas");
            }
            
          } else if (data.ResponseCode === 500 || data.ResponseCode === 450) {
            this.showErrorMessage(data.ResponseDetail);
          } else if (data.ResponseCode === 430) {
            this.showErrorMessage(data.ResponseDetail);
          }
        });
      });
    }else{
      this.setState({captchaError: true})
    }
  };

  setFormat = (date) => {
    if(!date) return "";
    let month =
      (date.getMonth() + 1).toString().length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    let day =
      date.getDate().toString().length === 1
        ? "0" + date.getDate()
        : date.getDate();
    let year = date.getFullYear();

    if (typeof date === "object") {
      return day + "/" + month + "/" + year;
    } else {
      return "";
    }
  };

  continueHandlerButton(e) {
    this.continueHandler()
  }

  handleBirthDayChange = (value) => {
    this.setState({
      dateBirth: value,
    })
  }

  inputDate() {
    return (
      <div className={'inputDateContainer'}>
        <div>
          <div className="dateLabel">Fecha de nacimiento</div>
          {/* {this.props.tooltip && this.props.tooltip()} */}
        </div>

        <div className="dateContainerInner">
          <DatePicker
            strings={this.dayPickerStrings}
            minDate={moment(moment().toDate())
              .subtract(100, "years")
              .toDate()}
            maxDate={moment().toDate()}
            value={this.state.dateBirth}
            onSelectDate={this.handleBirthDayChange}
            formatDate={(date) => this.setFormat(date)}
            allowTextInput={true}
            placeholder={`${"DD/MM/YYYY"}`}
            isMonthPickerVisible={true}
            showGoToToday={true}
            className="datePickerFabric"
            parseDateFromString={(dateStringInversa) => {
              const stringSplitted = dateStringInversa.split("/");
              if(stringSplitted.length !== 3) return dateStringInversa;
              const resolve = `${stringSplitted[1]}/${stringSplitted[0]}/${stringSplitted[2]}`;
              this.handleBirthDayChange(moment(resolve).toDate());
              return moment(resolve).toDate();
            }}
          />
        </div>
      </div>
    );
  }

  handleResponseSurvey(response, userTypeId, userId) {
    if (response.ResponseCode === 200) {
      const hasBeneficiaries = response.Result.filter((item) => {
        return item.IsContributor === true;
      });
      if (hasBeneficiaries.length === 0) {
        if (response.Result[0].SurveysList.length !== 0) {
          response.Result[0].SurveysList.sort((survey1, survey2) => {
            return survey2.ID - survey1.ID;
          });
        }
        this.props.handleSubmitFinish({
          surveys: response.Result,
          userInfo: {
            userTypeId,
            userId,
          },
        });
      } else {
        if (response.Result.length > 0) {
          if (response.Result[0].SurveysList.length !== 0) {
            response.Result[0].SurveysList.sort((survey1, survey2) => {
              return survey2.ID - survey1.ID;
            });
          }
        }
        this.props.handleSubmitFinish({
          surveys: response.Result,
          userInfo: {
            userTypeId,
            userId,
          },
        });
      }

      compensar.quitarLoading("#Landing-Encuestas");
    } else if (response.ResponseCode === 500 || response.ResponseCode === 450) {
      this.props.getErrorMessage(
        response.ResponseDetail,
        "Cerrar",
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.False"
        ),
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.True"
        )
      );
      this.setState({ error: true });
      compensar.quitarLoading("#Landing-Encuestas");
    } else if (response.ResponseCode === 430) {
      this.props.getErrorMessage(
        response.ResponseDetail,
        "Cancelar",
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.False"
        ),
        sharedResources.getResource(
          "es",
          "nsGeneralResources",
          "Modal.Bolean.True"
        )
      );
      compensar.quitarLoading("#Landing-Encuestas");
    }
    // this.props.handleSubmitFinish({
    //   userInfo: {
    //     userTypeId,
    //     userId,
    //   },
    //   surveys: result,
    // })
  }

  getSurveys({ userTypeId, userId }, callback) {
    api.post(
      `/_vti_bin/Servicios/ServicioTransarSurvey.svc/GetSurveyssl`,
      {
        userTypeId,
        userId,
      }
    ).then(({ data }) => {
      callback(data, userTypeId, userId)
    })
  }

  activeModal(
    title,
    btnCerrarCancelar,
    message,
    icono,
    colorIco,
    noX,
    noAceptar,
    noCancelar
  ) {
    this.setState({
      titleModal: title,
      btnCerrarCancelar: btnCerrarCancelar,
      messageModal: message,
      iconoModal: icono,
      colorIco: colorIco,
      noX: noX,
      noAceptar: noAceptar,
      noCancelar: noCancelar,
      showModal: true,
    });
  }
  handleDismiss() {
    this.setState({ show: false });
  }
  alertMessage() {
    return this.state.show === true ? (
      <Alert bsStyle="info" onDismiss={this.handleDismiss}>
        <div className="contentMessage">
          <p className="textMessage notIcon">
            <i
              className={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.iconMessage"
              )}
            ></i>
            {landingEncuestaResources.getResource(
              "es",
              "nsLandingEncuesta",
              "Form.Content.infoMessage"
            )}
          </p>
          <p className="textMessage spaceBr text-center">
            <i
              className={landingEncuestaResources.getResource(
                "es",
                "nsLandingEncuesta",
                "Form.Content.iconMessage"
              )}
            ></i>
            <br />
            {landingEncuestaResources.getResource(
              "es",
              "nsLandingEncuesta",
              "Form.Content.infoMessage"
            )}
          </p>
        </div>
      </Alert>
    ) : null;
  }

  getDataCatch() {
    return this.activeModal(
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Title.Error"
      ),
      "Cerrar",
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Lead.ErrorSistema"
      ),
      sharedResources.getResource("es", "nsGeneralResources", "Iconos.Error"),
      sharedResources.getResource("es", "nsGeneralResources", "Colores.Azul"),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.False"
      ),
      sharedResources.getResource(
        "es",
        "nsGeneralResources",
        "Modal.Bolean.True"
      )
    );
  }

  cleanHandler() {
    this.setState({
      tipoDocSelected: null,
      numeroDoc: '',
      dateBirth: null,
    });
  };

  handleTipoDocSelect(args) {
    this.setState({
      tipoDocSelected: args
    })
  }
  
  render() {
    return (
      <span>
        <h1>
          {"Encuestas de salud"}
        </h1>
        {this.alertMessage()}
        <Cards
          // title={"Tele.titulos.authSegundario"}
          title={"Las encuestas de salud son de carácter informativo y no reemplaza bajo ninguna circunstancia el diagnóstico médico"}
        >
          <div className="CardsContainer">
            <div className="ChildrenContainer">
              <div className={`Container`}>
                <div className="LabelContainer">
                  <p className="Label">Tipo de documento:</p>
                </div>
                <div className="InputContainer">
                  <Select
                    onChange={(args) => this.handleTipoDocSelect(args)}
                    options={this.props.tiposDocumentos}
                    value={this.state.tipoDocSelected}
                    className={'dropDown__menu'}
                    aria-labelledby="dropdownCedula"
                    placeholder={'Seleccione el tipo de documento'}
                    noOptionsMessage={() => {
                      // eslint-disable-next-line no-undef
                      return "Tele.views.search.pick.sites.noDataMenu";
                    }}
                    styles={customStyles}
                    components={{
                      MenuList: (inputProps) => <MenuList {...inputProps} scroll={scroll} />,
                    }}
                  />
                </div>
              </div>
            </div>
            
            <div className="ChildrenContainer">
              <div className={`Container`}>
                <div className="LabelContainer">
                  <p className="Label">Número de documento</p>
                </div>
                <div className="InputContainer">
                  <input
                    className="Input"
                    type="text"
                    onChange={(e) => {
                      if (isAlphanumeric(e.target.value)) {
                        this.setState({ numeroDoc: e.target.value });
                      }
                      if (e.target.value === "" && e.target.value.length === 0) {
                        this.setState({ numeroDoc: "" });
                      }
                    }}
                    value={this.state.numeroDoc}
                    maxLength={20}
                    placeholder={"Ingrese el número"}
                  />
                </div>
              </div>
            </div>

            {this.inputDate()}

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <div id="g-recaptcha" style={{ display: "inline-block" }}></div>
            </div>

            <div className={`Container extraclass`}>
              <input
                className="Limpiar"
                type="button"
                value="Limpiar"
                onClick={this.cleanHandler.bind(this)}
                aria-label="cleaning function"
              />
              <input
                className="Generate"
                type="button"
                value={'Continuar'}
                disabled={
                  this.state.tipoDocSelected && 
                  this.state.numeroDoc && 
                  this.state.captchaVerified &&
                  this.state.dateBirth
                  ? false
                  : true
                }
                onClick={this.continueHandlerButton.bind(this)}
                aria-label="generate function"
              />
            </div>
          </div>
        </Cards>
      </span>
    );
  }
};
